import type { SVGProps } from 'react'

const iconProps: SVGProps<SVGSVGElement> = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
}

/** Data Platform – stacked layers / database */
export function IconDataPlatform(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
      <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
    </svg>
  )
}

/** Data Migration – transfer / arrows */
export function IconDataMigration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M7 16V4l-4 4" />
      <path d="M3 8h10a4 4 0 0 1 4 4v4" />
      <path d="M17 8v12l4-4" />
      <path d="M21 16H11a4 4 0 0 1-4-4V8" />
    </svg>
  )
}

/** Cloud Adoption – cloud */
export function IconCloud(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  )
}

/** Data Quality and Masking – shield with check */
export function IconDataQuality(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  )
}

/** Business Data Transformations – circular arrows */
export function IconTransform(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1 6.74-2.74L21 16" />
      <path d="M21 21v-5h-5" />
    </svg>
  )
}

/** Digital Solutions Engineering – code / bracket */
export function IconEngineering(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  )
}

/** Data Consultancy – document with person */
export function IconConsultancy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      <path d="M14 2v6h6" />
      <path d="M14 2l4 4" />
    </svg>
  )
}

/** Data Integration – connected nodes */
export function IconIntegration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <circle cx="12" cy="5" r="3" />
      <circle cx="5" cy="19" r="3" />
      <circle cx="19" cy="19" r="3" />
      <path d="M12 8v3l-5 5" />
      <path d="M12 8v3l5 5" />
    </svg>
  )
}

/** Data Governance – document / checklist */
export function IconGovernance(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
      <path d="M10 9H8" />
    </svg>
  )
}

/** Artificial Intelligence – brain / neural */
export function IconAI(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v2a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 5.76-1.26" />
      <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v2a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-5.76-1.26" />
      <path d="M12 10v4" />
      <path d="M12 18a2 2 0 0 1 2 2v2" />
      <path d="M12 18a2 2 0 0 0-2 2v2" />
      <path d="M8 14v2a4 4 0 0 0 8 0v-2" />
    </svg>
  )
}

/** BI and Analytics – bar chart */
export function IconBIAnalytics(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...props}>
      <line x1="12" y1="20" x2="12" y2="10" />
      <line x1="18" y1="20" x2="18" y2="4" />
      <line x1="6" y1="20" x2="6" y2="16" />
    </svg>
  )
}

const icons = [
  IconDataPlatform,
  IconDataMigration,
  IconCloud,
  IconDataQuality,
  IconTransform,
  IconEngineering,
  IconConsultancy,
  IconIntegration,
  IconGovernance,
  IconAI,
  IconBIAnalytics,
] as const

export function ServiceIcon({ index, className, ...props }: { index: number } & SVGProps<SVGSVGElement>) {
  const Icon = icons[index % icons.length]
  return <Icon className={className} {...props} />
}
